"use client";

import clsx from "clsx";
// import Image from "next/image";
// import { useState } from 'react';
// import clsx from 'clsx';
// import { avenirNextMedium, avenirNextDemi } from '@/styles/fonts'
import dynamic from "next/dynamic";
import { FormEvent, useRef, useState } from "react";
import TurnstileWidget, { type TurnstileWidgetHandle } from "@/app/components/TurnstileWidget.client";

//export default 
function Message(props: {
  classInput: string, classButton: string
}) {
  const [resp, setResp] = useState("");
  const [turnstileToken, setTurnstileToken] = useState('');
  const turnstileRef = useRef<TurnstileWidgetHandle>(null);
  const handleSubmut = (event: FormEvent<HTMLFormElement>) => {

    event.preventDefault()
    if (!turnstileToken) {
      setResp("<h1>Please complete verification</h1>");
      return;
    }

    const formData = new FormData(event.currentTarget);
    formData.set('cf-turnstile-response', turnstileToken);
    fetch("/ajax/form_message", {
      method: "POST",
      body: formData,
    }).catch((e) => {
      setResp("<h1>Internal Error</h1>");
      turnstileRef.current?.reset();
      setTurnstileToken('');
      throw e; // rethrow to send to sentry
    }).then(async (response: Response) => {
      const body = await response.text();
      if (!response.ok) {
        setResp("<h1>Internal Error</h1>");
        turnstileRef.current?.reset();
        setTurnstileToken('');
      } else {
        const regex = /<h1\>([A-Za-z ]+)<\/h1>/;
        const msg = body.match(regex);
        setResp(msg && msg.length > 1 ? msg[1] : "<h1>Internal Error</h1>");
      }
    });
  };

  return (
    <div suppressHydrationWarning>
      <form suppressHydrationWarning data-lpignore="true" onSubmit={handleSubmut}>
        <div className={clsx(resp == "" && "hidden", "text-36px text-[#86939e]")}>{resp}</div>
        { /* border-color: #3c763d; // success
            border-color: #a94442; // error
            ?? blue focus ??
            light gray default  #ccc;
        */ }
        <div className={clsx(resp != "" && "hidden")}>
          <input suppressHydrationWarning data-lpignore="true" autoComplete="off" name="email"
            className={props.classInput} placeholder="Email" />
          <input suppressHydrationWarning data-lpignore="true" autoComplete="off" name="subject"
            className={props.classInput} placeholder="Subject" />
          <textarea suppressHydrationWarning data-lpignore="true" autoComplete="off" rows={4} name="message"
            className={props.classInput} placeholder="Message" />
          <div className="mb-[10px]">
            <TurnstileWidget
              ref={turnstileRef}
              action="contact_message"
              onTokenChange={setTurnstileToken}
            />
          </div>
          <button className={props.classButton}>Submit</button>
        </div>
      </form>
    </div>
  )
}

// suppressHydrationWarning don't work here because lastpass insert icon root to parent div
export default dynamic(() => Promise.resolve(Message), { ssr: false });
